// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.viviendas-nav-container {
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 24px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.viviendas-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.viviendas-title {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #2c3e50;
}

.viviendas-title .icon {
  font-size: 20px;
}

.add-vivienda-btn {
  background: #f09502;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 0.5rem 0.8rem;
  display: flex;
  align-items: center;
  gap: 0.4rem;
  cursor: pointer;
  font-size: 0.8rem;
  font-weight: 500;
  transition: all 0.3s ease;
  margin-top: 0.5rem;
  height: 40px;
  width: 100%;
  justify-content: center;
  max-width: 120px;
}

.add-vivienda-btn:hover {
  background: #e08502;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(240, 149, 2, 0.3);
}

.add-vivienda-btn .icon {
  font-size: 16px;
}

.viviendas-list {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 16px;
}

.vivienda-item {
  display: flex;
  align-items: center;
  gap: 8px;
  background: white;
  border: 2px solid #e9ecef;
  border-radius: 10px;
  padding: 4px;
  transition: all 0.2s ease;
}

.vivienda-item.active {
  border-color: #f09502;
  box-shadow: 0 2px 8px rgba(240, 149, 2, 0.2);
}

.vivienda-select-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  background: transparent;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 120px;
  text-align: left;
}

.vivienda-select-btn:hover {
  background: #f8f9fa;
}

.vivienda-select-btn.active {
  background: #f09502;
  color: white;
}

.vivienda-number {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  background: #6c757d;
  color: white;
  border-radius: 50%;
  font-size: 12px;
  font-weight: 600;
}

.vivienda-select-btn.active .vivienda-number {
  background: rgba(255, 255, 255, 0.3);
}

.vivienda-name {
  font-size: 14px;
  font-weight: 500;
  color: #495057;
}

.vivienda-select-btn.active .vivienda-name {
  color: white;
}

.set-cover-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  width: auto;
  min-width: 32px;
  height: 32px;
  padding: 0 8px;
  background: transparent;
  color: #ccc;
  border: 1px solid transparent;
  border-radius: 16px;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 14px;
}

.set-cover-btn:hover {
  color: #f09502;
  background: rgba(240, 149, 2, 0.05);
}

.set-cover-btn.is-cover {
  color: #f09502;
  background: rgba(240, 149, 2, 0.1);
  border-color: rgba(240, 149, 2, 0.2);
}

.set-cover-btn.is-cover:hover {
  background: rgba(240, 149, 2, 0.15);
}

.cover-label {
  font-size: 12px;
  font-weight: 600;
}

.remove-vivienda-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background: #dc3545;
  color: white;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 12px;
}

.remove-vivienda-btn:hover {
  background: #c82333;
  transform: scale(1.1);
  box-shadow: 0 2px 8px rgba(220, 53, 69, 0.3);
}

.remove-vivienda-btn:active {
  transform: scale(0.95);
}

.viviendas-info {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 12px;
  border-top: 1px solid #e9ecef;
}

.viviendas-count {
  font-size: 14px;
  color: #6c757d;
  font-weight: 500;
}

/* Responsive */
@media (max-width: 768px) {
  .viviendas-header {
    flex-direction: column;
    gap: 12px;
    align-items: stretch;
  }

  .viviendas-list {
    flex-direction: column;
  }

  .vivienda-item {
    width: 100%;
  }

  .vivienda-select-btn {
    flex: 1;
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/components/new-proyect/new-project-viviendas-nav/new-project-viviendas-nav.component.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,eAAe;EACf,YAAY;EACZ,cAAc;EACd,uBAAuB;EACvB,WAAW;EACX,6BAA6B;EAC7B,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,kCAAkC;EAClC,oCAAoC;AACtC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE;IACE,sBAAsB;IACtB,SAAS;IACT,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,OAAO;EACT;AACF","sourcesContent":[".viviendas-nav-container {\n  background: #f8f9fa;\n  border: 1px solid #e9ecef;\n  border-radius: 12px;\n  padding: 20px;\n  margin-bottom: 24px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n.viviendas-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 16px;\n}\n\n.viviendas-title {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin: 0;\n  font-size: 18px;\n  font-weight: 600;\n  color: #2c3e50;\n}\n\n.viviendas-title .icon {\n  font-size: 20px;\n}\n\n.add-vivienda-btn {\n  background: #f09502;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  padding: 0.5rem 0.8rem;\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  cursor: pointer;\n  font-size: 0.8rem;\n  font-weight: 500;\n  transition: all 0.3s ease;\n  margin-top: 0.5rem;\n  height: 40px;\n  width: 100%;\n  justify-content: center;\n  max-width: 120px;\n}\n\n.add-vivienda-btn:hover {\n  background: #e08502;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 8px rgba(240, 149, 2, 0.3);\n}\n\n.add-vivienda-btn .icon {\n  font-size: 16px;\n}\n\n.viviendas-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  margin-bottom: 16px;\n}\n\n.vivienda-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background: white;\n  border: 2px solid #e9ecef;\n  border-radius: 10px;\n  padding: 4px;\n  transition: all 0.2s ease;\n}\n\n.vivienda-item.active {\n  border-color: #f09502;\n  box-shadow: 0 2px 8px rgba(240, 149, 2, 0.2);\n}\n\n.vivienda-select-btn {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 16px;\n  background: transparent;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  min-width: 120px;\n  text-align: left;\n}\n\n.vivienda-select-btn:hover {\n  background: #f8f9fa;\n}\n\n.vivienda-select-btn.active {\n  background: #f09502;\n  color: white;\n}\n\n.vivienda-number {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  background: #6c757d;\n  color: white;\n  border-radius: 50%;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.vivienda-select-btn.active .vivienda-number {\n  background: rgba(255, 255, 255, 0.3);\n}\n\n.vivienda-name {\n  font-size: 14px;\n  font-weight: 500;\n  color: #495057;\n}\n\n.vivienda-select-btn.active .vivienda-name {\n  color: white;\n}\n\n.set-cover-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  width: auto;\n  min-width: 32px;\n  height: 32px;\n  padding: 0 8px;\n  background: transparent;\n  color: #ccc;\n  border: 1px solid transparent;\n  border-radius: 16px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  font-size: 14px;\n}\n\n.set-cover-btn:hover {\n  color: #f09502;\n  background: rgba(240, 149, 2, 0.05);\n}\n\n.set-cover-btn.is-cover {\n  color: #f09502;\n  background: rgba(240, 149, 2, 0.1);\n  border-color: rgba(240, 149, 2, 0.2);\n}\n\n.set-cover-btn.is-cover:hover {\n  background: rgba(240, 149, 2, 0.15);\n}\n\n.cover-label {\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.remove-vivienda-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  background: #dc3545;\n  color: white;\n  border: none;\n  border-radius: 50%;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-size: 12px;\n}\n\n.remove-vivienda-btn:hover {\n  background: #c82333;\n  transform: scale(1.1);\n  box-shadow: 0 2px 8px rgba(220, 53, 69, 0.3);\n}\n\n.remove-vivienda-btn:active {\n  transform: scale(0.95);\n}\n\n.viviendas-info {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding-top: 12px;\n  border-top: 1px solid #e9ecef;\n}\n\n.viviendas-count {\n  font-size: 14px;\n  color: #6c757d;\n  font-weight: 500;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .viviendas-header {\n    flex-direction: column;\n    gap: 12px;\n    align-items: stretch;\n  }\n\n  .viviendas-list {\n    flex-direction: column;\n  }\n\n  .vivienda-item {\n    width: 100%;\n  }\n\n  .vivienda-select-btn {\n    flex: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
